import { Workspace } from '@anm/api/modules/team';
import { flexCenter } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

import { defaultAvatar } from '.';
import { Avatar, Description, Title } from './Wrapper';

export type DropdownItemProps = {
  workspace: Workspace;
  title?: string;
  avatar?: string;
  onClick?: (workspace: Workspace) => void;
};

const Wrapper = styled.div`
  ${flexCenter}

  width: 100%;
  justify-content: start;
  min-width: 150px;
  padding: 9px 15px;
  cursor: pointer;

  &:hover {
    background: #f4f6f7;
  }
`;

const nameMap: { [key in Workspace]: string } = { team: 'Team', user: 'My' };
const DropdownItem: FC<DropdownItemProps> = ({ title, avatar, workspace, onClick }) => (
  <Wrapper onClick={() => onClick?.(workspace)}>
    <Avatar src={avatar || defaultAvatar} alt="workspace dropdown avatar" />
    <div>
      {title && <Title>{title}</Title>}
      <Description>{nameMap[workspace]} workspace</Description>
    </div>
  </Wrapper>
);

export default DropdownItem;
